import ClassActivityPanel from "./panels/ClassActivityPanel";

const tabRoutes = [
  {
    name: "Class Activity",
    path: "/classactivity",
    component: <ClassActivityPanel />
  }
];

export default tabRoutes;
